export const FF_ON = '1' as const;
export const FF_OFF = '0' as const;

export const FEATURE_FLAGS = {
  ESTIMATE_TAP_REDESIGN: 'estimateTapRedesign',
  SURCHARGE_AUTOMATION: 'surchargeAutomation',
  SIGNED_DOCUMENT_CODE_VERIFICATION: 'signedDocumentCodeVerification',
} as const;
